import { render, staticRenderFns } from "./readOnlyTextField.template?vue&type=template&id=0ea8ed6a&lang=pug&"
import script from "./readOnlyTextField.client?vue&type=script&lang=ts&"
export * from "./readOnlyTextField.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea8ed6a')) {
      api.createRecord('0ea8ed6a', component.options)
    } else {
      api.reload('0ea8ed6a', component.options)
    }
    module.hot.accept("./readOnlyTextField.template?vue&type=template&id=0ea8ed6a&lang=pug&", function () {
      api.rerender('0ea8ed6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/readOnlyTextField/readOnlyTextField.component.vue"
export default component.exports